import React, { useEffect, useState } from "react";
import { fadeIn, slideIn, staggerContainer, } from "../utils/motion";
import { motion } from "framer-motion";
import { useSelector } from "react-redux";
import TruncateText from "../TruncateText";
const FloorSection = ({lang,FloorBlocks,text}) => {
  const [show,setShow] = useState(false)
  const [index,setIndex] = useState(0)
 
    
const [width, setWidth] = useState(window.innerWidth);
  
useEffect(() => {
  const handleResize = () => setWidth(window.innerWidth);
  window.addEventListener("resize", handleResize);
//  console.log(window.innerWidth);
  return () => window.removeEventListener("resize", handleResize);
}, []);


useEffect(() => {

  setTimeout(() => {
    setShow(true);
}, 500);
  
}, []);

const [more, setMore] = useState(false)
const data = useSelector((state) => state.cart.constants);   
  return (
    <motion.section
    variants={staggerContainer()}
   initial='hidden'
   whileInView='show'
   viewport={{  amount: 0.25 }}
    dir="rtl" 
    className ={`relative bg-[#F4F4F4] mt-[16px] xl:mt-[8px] lg:mt-[8px] md:sm:mt-[8px]   w-full `}>
    <span className='hash-span' id={'FloorSection'}>
   
   </span>
   <motion.div variants={slideIn('right', '', 0.1, 1)} >
    <div  className={`bg-[#F4F4F4] relative h-[250px] xl:h-[450px] lg:h-[400px] md:h-[350px] sm:h-[300px] xs:h-[250px]  w-full`}>


    <img
          src="../../img/floor.png"
          alt="الحبيشي البلاط"
       width='45%'
       height='auto'
       style={{marginBottom:"-9%",zIndex:1}}
       className="absolute drop-shadow-xl bottom-0 left-0 xl:max-w-[500px] lg:max-w-[450px]  md:max-w-[400px] min-w-[200px] "


        />

        
    <div dir="rtl" className="flex w-full">
<div className="w-[50%] flex flex-col self-stretch my-auto text-[#323131] pt-10  pr-10 p-1 ">
   {  text&&    <>          

                      <motion.h2 variants={fadeIn('right','',1,0.7)} style={{fontFamily:'CairoExtraBold'}} className={`${lang === 'en' ? 'text-left' :'text-right'}  text-[20px]  lg:text-[50px]  md:text-[40px]  sm:text-[30px]  xs:text-[20px]  `} >
                     {  lang=== 'en' ? 'Tails' :' البلاط'}
                      </motion.h2>
                      <motion.p style={{height:`${(width/2)/5}px`,overflowY:'auto',whiteSpace:more?'pre-wrap':''}} variants={fadeIn('right','',1,0.7)}  className={`${lang === 'en' ? 'text-left' :'text-right'} text-[8px] xl:text-[20px] lg:text-[16px] md:text-[13px] sm:text-[10px] xs:text-[8px]`} >
                 {    
                  lang=== 'en' ?  
                      
                        
                    data&&data.length ?
                        
                      
                      data&&data[4].value_en?.length > 150 ? 
                          <>
                        {more ? data&&data[4].value_en : TruncateText(data&&data[4].value_en , 150)}
                        <span className='text-blue-500 cursor-pointer' onClick={()=>{setMore(!more)}} >
                        
                        {more ?'Less' : 'More'}
                        
                        </span> 
                        </>
                        :data&&data[4].value_en 
                    
                     :''
    
    
    
                  : 
                    
    
                       data&&data.length ?
                        
                      
                        data&&data[4].value?.length > 150 ? 
                            <>
                          {more ? data&&data[4].value : TruncateText(data&&data[4].value , 150)}
                          <span className='text-blue-500 cursor-pointer' onClick={()=>{setMore(!more)}} >
                          
                      
                          { more ?  'الغاء' : 'المزيد'}
                          </span> 
                          </>
                          :data&&data[4].value 
                      
                       :''
                        }
    
                 
                   
                  
                      </motion.p>
                    
                      </>   
                      }
            </div>
</div>




  <div dir="rtl" style={{overflowX:'auto',zIndex:2}} className={`w-[55%] absolute right-0  bottom-[12%]  flex    p-1 `} >
  

        <div   className={`${width >= 1000 ? '  m-auto  flex  gap-1' : 'm-auto flex flex-nowrap  gap-1'} ` } >
          {FloorBlocks.length > 0 ?
            FloorBlocks.map((block, i) => (
            <button
            key={i}
            onClick={()=>{
              if(index !== i){
                setShow(false)
              setIndex(i)
              setTimeout(() => {
            setShow(true);
        }, 500);
              }
              
              
              }}
    //style={{backgroundColor:block.color}}

      className={`flex text-center transition delay-150 duration-300 ${index=== i ? '-translate-y-1' :''}  h-[80px] w-[80px] shadow-[0px_3px_3px_rgba(0,0,0,0.25)] rounded  ${index === i ? 'border-[1px] border-white':''} `}
    >
 
   
        <img
          src={`https://alhubaishi.future-swift.com/products/${block.src}`}
          alt={block.alt}
       width='80px'
       height='80px'
  
       className="absolute rounded z-0"


        />
   

    </button>
          
          
          )):''}
        </div>

        </div>
  </div>


    
 {FloorBlocks.length > 0 ?
   <div  style={{ zIndex:0, backgroundImage: `url(https://alhubaishi.future-swift.com/products/${FloorBlocks[index].src})`,backgroundRepeat:'round' , backgroundSize:'100px' }}
    className={`${show ? 'opacity-[1] -translate-y-[25px]' : 'opacity-[0] translate-y-[25px]'} transition-all delay-150 duration-300  w-full h-[202px]  `} />
  :'' }
   </motion.div>
    </motion.section>
  );
}; 

export default FloorSection;
